import axios from 'axios';
import { Message, Loading } from 'element-ui';

const config = require('../../../httpConfig');

/**
 * A Client to Cybertron nodejs using Ajax.
 */
class Client {
  constructor() {
    // It's possible to override the address by a querystring.
    const hostDev = config.dev;
    const hostProd = config.prod;
    let addressQ = '';
    // The nodejs is serving the page so using the same address.
    // console.log(process.env.NODE_ENV, process.env.VUE_APP_HOST_ENV);
    if (process.env.NODE_ENV === 'development') {
      addressQ = '';
    } else if (process.env.NODE_ENV === 'production') {
      if (process.env.VUE_APP_HOST_ENV === 'dev') {
        addressQ = hostDev ? `${hostDev}` : null;
      } else {
        addressQ = hostProd ? `${hostProd}` : null;
      }
    }

    this.address = addressQ;
    this.url = `${addressQ}`;
    this.axiosInstance = this.initAxios();
  }

  async get(path) {
    const res = await this.axiosInstance.get(this.url + path, {
      responseType: 'json',
      withCredentials: true,
      validateStatus: () => true,
    });
    return res;
  }

  async post(path, data, uploadConifg = {}) {
    const res = await this.axiosInstance.post(this.url + path, data, uploadConifg);
    return res;
  }

  async upload(path, fileFormData, uploadConifg) {
    const res = await this.axiosInstance.post(path, fileFormData, uploadConifg);
    return res;
  }

  refeshToken() {
    this.axiosInstance = this.initAxios();
  }

  // eslint-disable-next-line class-methods-use-this
  initAxios() {
    let loadingInstance = null;
    const axiosInstance = axios.create({
      timeout: 360000,
      headers: {
        token: localStorage.getItem('token'),
      },
    });
    axiosInstance.interceptors.request.use((requestConfig) => {
      loadingInstance = Loading.service({ fullscreen: true, background: 'transparent', text: '努力加载中...' });
      return requestConfig;
    });
    // axios response intercept
    axiosInstance.interceptors.response.use((res) => {
      loadingInstance.close();
      const { data } = res;
      if (res.config.url.indexOf('ali/oss') > -1) {
        return data;
      }
      if (res.config.url.indexOf('aliyuncs') > -1) {
        return data;
      }
      if (data.code === '10000') {
        return data.data ? data.data : [];
      }
      Message.error(data.msg);
      if (data.code === '20300') {
        localStorage.removeItem('token');
        window.location.reload();
      }
      if (data.msg.indexOf('权限') !== -1) {
        window.history.go(-1);
      }
      return null;
    }, (err) => {
      loadingInstance.close();
      Message.error('网络错误');
      return Promise.reject(err);
    });
    return axiosInstance;
  }
}
export default new Client();
